






























import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex'

export default Vue.extend({
  name: 'MainNavbar',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'sessionUserIsFullyLoggedIn',
      'sessionUser',
      'sessionUserHomePage'
    ])
  },
  methods: {
    ...mapActions([
      'logState'
    ]),

    goHome () {
      const homePage = this.$store.getters.sessionUserHomePage
      if (homePage !== this.$route.path) this.$router.push(this.$store.getters.sessionUserHomePage)
    },

    async logout () {
      await this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
})
